import { render, staticRenderFns } from "./VirtualClassroomLectureList.vue?vue&type=template&id=70253cd6&"
import script from "./VirtualClassroomLectureList.vue?vue&type=script&lang=js&"
export * from "./VirtualClassroomLectureList.vue?vue&type=script&lang=js&"
import style0 from "./VirtualClassroomLectureList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
